import { Injectable } from '@angular/core';

declare var fullpage: any;

@Injectable({
    providedIn: 'root'
})
export class FullpageService {
    private fullpageApi: any = null;

    constructor() { }

    init(selector: string, config: any): void {
        if (this.fullpageApi) {
            this.destroy();
        }

        // Wait for fullpage.js library to be loaded
        this.waitForFullpage().then(() => {
            this.fullpageApi = new fullpage(selector, config);
            console.log('Fullpage.js initialized successfully', this.fullpageApi);
        }).catch(error => {
            console.error('Failed to initialize fullpage.js:', error);
        });
    }

    private waitForFullpage(): Promise<void> {
        return new Promise((resolve, reject) => {
            let attempts = 0;
            const maxAttempts = 50; // 5 seconds max wait

            const checkFullpage = () => {
                if (typeof fullpage !== 'undefined') {
                    resolve();
                } else if (attempts < maxAttempts) {
                    attempts++;
                    setTimeout(checkFullpage, 100);
                } else {
                    reject(new Error('Fullpage.js library not found'));
                }
            };

            checkFullpage();
        });
    }

    getApi(): any {
        return this.fullpageApi;
    }

    destroy(): void {
        if (this.fullpageApi) {
            this.fullpageApi.destroy('all');
            this.fullpageApi = null;
        }
    }

    moveTo(section: string | number, slide?: number): void {
        if (this.fullpageApi) {
            this.fullpageApi.moveTo(section, slide);
        }
    }

    moveSlideRight(): void {
        if (this.fullpageApi) {
            this.fullpageApi.moveSlideRight();
        }
    }

    moveSlideLeft(): void {
        if (this.fullpageApi) {
            this.fullpageApi.moveSlideLeft();
        }
    }

    moveSectionUp(): void {
        if (this.fullpageApi) {
            this.fullpageApi.moveSectionUp();
        }
    }

    moveSectionDown(): void {
        if (this.fullpageApi) {
            this.fullpageApi.moveSectionDown();
        }
    }
} 